import { createQuery } from 'Common/utils/network/querykit'
import { getAirCraftsFiltered } from 'API/definitions/iris/aircraft'
import { buildAircraftImageUrl } from 'API/utils'

const useGetAirCraftsFiltered = createQuery<any, any, Error>({
  primaryKey: `aircrafts_filtered`,
  queryFn: ({ queryKey: [primaryKey, variables] }) => {
    return getAirCraftsFiltered(variables?.filterQueryParams)
  },
  select: (data) => buildAircraftImageUrl(data),
})

export { useGetAirCraftsFiltered }
